// extracted by mini-css-extract-plugin
module.exports = {"h1":"Home_h1__YOsby","h2":"Home_h2__1g2eM","offline":"Home_offline__1Y1la"};